export default __webpack_public_path__ + "static/media/facebook.cdde1a35.svg";